<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2 class="modal-title">Gizlilik Politikası</h2>
        <button class="close-button" @click="closeModal">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="privacy-content">
          <div class="intro-section">
            <p>Bu gizlilik politikası, veri sorumlusu sıfatıyla <strong>ibilityapp.com</strong> adresinde kurulu <strong>Ibility Teknoloji Anonim Şirketi</strong> tarafından 6698 Sayılı Kişisel Verilerin Korunması Kanunun (KVKK) çerçevesinde kişisel verilerinizin toplanma yöntemleri, işlenmesi, kullanılması, aktarılması, imha edilmesi konularında tarafınıza bilgi vermek maksadıyla düzenlenmiştir.</p>
            <p>İşbu aydınlatma metni şirketin tüm ürünleri, web siteleri, uygulamaları ve hizmetleri için geçerlidir. Müşteri gizliliğini ve kişisel verilerin korunmasını ciddiye alıyoruz.</p>
          </div>

          <h3>1. Kişisel Bilgi Toplama, Toplanma Amacı ve Kullanma</h3>
          <p>Ibility olarak ziyaretçi ve üyelerine ait kişisel verileri, 6698 sayılı Kişisel Verilerin Korunması Kanunu'na, yasal mevzuata ve Kişisel Verileri Koruma Kurumu kararlarına uygun şekilde işliyoruz.</p>
          
          <p><strong>Toplanan Kişisel Veriler:</strong></p>
          <ul>
            <li>Adınız, soyadınız</li>
            <li>Telefon numaranız, adresiniz, e-posta adresiniz</li>
            <li>Acil durumlarda ulaşılacak kişinin adı-soyadı ve telefon numarası</li>
            <li>IP ve Device IP bilgisi</li>
            <li>Kredi kartı ve banka bilgileri</li>
            <li>Sağlık durumu bilgisi, cinsiyet ve yaş bilgisi</li>
            <li>Paylaşılan içerikte yer alan fotoğraf, video kayıtları</li>
            <li>İçeriklere yapılan yorumlar ve görüşme kayıtları</li>
          </ul>

          <p><strong>Özel Nitelikli Kişisel Veriler:</strong></p>
          <p>KVKK m.6'da belirtilen kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik verileri özel nitelikli kişisel veridir. Bu verilerin işlenmesi için açık rızanız gereklidir.</p>

          <p><strong>Veri İşleme Amaçları:</strong></p>
          <ul>
            <li>Ibility faaliyetlerinin ilgili mevzuata uygun yürütülmesi</li>
            <li>Ziyaretçilere ve üyelere daha iyi hizmet sunabilmesi</li>
            <li>Ürün/hizmet teklifi, bilgilendirme, reklam-tanıtım faaliyetleri</li>
            <li>İlgi alanlarına ve tercihlerine yönelik geliştirme çalışmaları</li>
            <li>Hukuki ve ticari güvenliğin sağlanması</li>
            <li>Ticari ve iş stratejilerinin belirlenmesi</li>
            <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            <li>Üyeler ile iletişime geçilmesi</li>
            <li>Elektronik Ticari İletiler Kanunu kapsamında ticari ileti gönderimi</li>
          </ul>

          <h3>2. Kişisel Bilgi İşlemenin Dayandığı Hukuki Sebepler</h3>
          <p>Veri işleme KVKK'nın 5/2 maddesi uyarınca aşağıdaki sebeplere dayanmaktadır:</p>
          <ul>
            <li><strong>(a)</strong> Kanunlarda açıkça öngörülen sebepler</li>
            <li><strong>(c)</strong> Sözleşmenin kurulması veya ifası için zorunluluk</li>
            <li><strong>(ç)</strong> Veri sorumlusu sıfatıyla hukuki yükümlülüklerin yerine getirilmesi</li>
            <li><strong>(e)</strong> Bir hakkın tesis, koruma ve kullanımı için zorunluluk</li>
          </ul>
          <div class="important-note">
            <p><strong>Önemli:</strong> Bu verilerin işlenmesi rızanıza tabi değildir. Bu nedenle, hizmetin ve yasanın gerektirdiği muhafaza sürelerinin sonuna kadar kişisel verilerinizin silinmesini veya yok edilmesini talep etme hakkına sahip olmadığınızı belirtiriz.</p>
          </div>

          <h3>3. Kişisel Verilerin Aktarılması</h3>
          <p>Müşterilerimizin kişisel bilgileri, onayları olmadan üçüncü taraflarla paylaşılmaz veya satılmaz. Ancak, yasal gereksinimlerin yerine getirilmesi veya hizmetlerin sağlanması için yetkilendirilmiş iş ortaklarıyla bilgi paylaşımı yapılabilir.</p>
          
          <p><strong>Türkiye İçi Veri Aktarımı Koşulları:</strong></p>
          <ul>
            <li>Kanun gereği aktarım</li>
            <li>Sözleşmenin kurulması ve/veya ifası için zorunlu aktarım</li>
            <li>Hukuki yükümlülüğün yerine getirilmesi</li>
            <li>Bir hakkın tesisi, kullanılması veya korunması için zorunluluk</li>
          </ul>

          <h3>4. Kişisel Verilerin Korunması, Saklama Süresi ve İmhası</h3>
          <p><strong>Güvenlik Önlemleri:</strong></p>
          <ul>
            <li>Hukuka aykırı işlemenin önlenmesi</li>
            <li>Hukuka aykırı erişimin engellenmesi</li>
            <li>Fiziksel, teknik ve idari güvenlik tedbirleri</li>
            <li>Uygun teknik ve organizasyonel önlemler</li>
          </ul>
          
          <p><strong>Saklama Süresi:</strong> Kişisel verileriniz, hizmet ilişkisinin sona erdiği tarihten itibaren <strong>10 (on) yıl</strong> süreyle saklanmaktadır.</p>
          
          <p><strong>Pazarlama Verileri:</strong> Pazarlama amacıyla işlenen veriler hizmet süresi ile sınırlıdır.</p>
          
          <p><strong>Veri İmhası:</strong> Belirlenen süreler sonunda kişisel verileriniz silinecek, yok edilecek veya anonim hale getirilecektir.</p>

          <h3>5. Veri Sahibinin Hakları</h3>
          <p>Veri sahibi olarak aşağıdaki haklara sahipsiniz:</p>
          <ul>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
            <li>İşlenme amacını ve uygun kullanılıp kullanılmadığını öğrenme</li>
            <li>Aktarıldığı üçüncü kişileri bilme</li>
            <li>Düzeltilmesini isteme</li>
            <li>Silinmesini isteme</li>
            <li>İşlemlerin üçüncü kişilere bildirilmesini isteme</li>
            <li>Analiz sonuçlarına itiraz etme</li>
            <li>İşlenmesinin sınırlanmasını talep etme</li>
            <li>Zarar durumunda giderilmesini isteme</li>
          </ul>

          <div class="contact-info">
            <p><strong>Başvuru:</strong> Bu haklarınızı kullanmak için <strong>kisiselveri@ibilityapp.com</strong> adresine başvurabilirsiniz. Talebiniz en geç <strong>30 gün</strong> içinde sonuçlandırılacaktır.</p>
          </div>

          <h3>6. Veri Sorumlusunun Kimliği</h3>
          <div class="company-info">
            <p><strong>Şirket Unvanı:</strong> İBİLİTY TEKNOLOJİ ANONİM ŞİRKETİ</p>
            <p><strong>Mersis No:</strong> 1008207</p>
            <p><strong>Adres:</strong> KOZYATAĞI MAH. DEĞİRMEN SK. NIDA KULE A BLOK NO: 18 İÇ KAPI NO: 19 / KADIKÖY</p>
            <p><strong>Telefon:</strong> +90 212 355 89 50</p>
            <p><strong>E-Posta:</strong> info@ibilityapp.com</p>
          </div>

          <h3>7. İletişim</h3>
          <p>Gizlilik politikamızla ilgili herhangi bir sorunuz veya endişeniz varsa, lütfen bizimle iletişime geçmekten çekinmeyin.</p>

          <div class="notice">
            <p><strong>NOT:</strong> Bu gizlilik politikası, değişen yasal gereksinimlere, teknolojik gelişmelere ve işletme ihtiyaçlarına bağlı olarak zaman zaman güncellenebilir. Politikadaki değişiklikler web sitemizde yayınlanacaktır.</p>
          </div>
          
          <p class="last-updated">Son güncellenme: 09.05.2024</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyTextModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0;
}

.modal-title {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 24px;
  color: #111827;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  color: #6b7280;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(85vh - 100px);
}

.privacy-content {
  line-height: 1.6;
}

.intro-section {
  background-color: #f8fafc;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  border-left: 4px solid #4A68F8;
}

.intro-section p {
  margin: 0 0 12px 0;
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #374151;
}

.intro-section p:last-child {
  margin-bottom: 0;
}

.privacy-content h3 {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 18px;
  color: #111827;
  margin: 32px 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.privacy-content h3:first-of-type {
  margin-top: 0;
}

.privacy-content p {
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 16px;
  text-align: justify;
}

.privacy-content ul {
  margin: 16px 0;
  padding-left: 24px;
}

.privacy-content li {
  font-family: euclid_regular, 'sans-serif';
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 8px;
  line-height: 1.5;
}

.important-note {
  background-color: #fef3cd;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.important-note p {
  margin: 0;
  color: #92400e;
  font-size: 14px;
}

.contact-info {
  background-color: #eff6ff;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.contact-info p {
  margin: 0;
  color: #1e40af;
  font-size: 14px;
}

.company-info {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
}

.company-info p {
  margin: 8px 0;
  font-size: 14px;
  color: #374151;
}

.company-info p:first-child {
  margin-top: 0;
}

.company-info p:last-child {
  margin-bottom: 0;
}

.notice {
  background-color: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  padding: 16px;
  margin: 20px 0;
}

.notice p {
  margin: 0;
  color: #0c4a6e;
  font-size: 13px;
  font-style: italic;
}

.last-updated {
  font-size: 12px !important;
  color: #9ca3af !important;
  font-style: italic;
  margin-top: 32px !important;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  text-align: center !important;
  font-weight: 500;
}

@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
  }
  
  .modal-content {
    max-height: 90vh;
    max-width: 95%;
  }
  
  .modal-header {
    padding: 16px 16px 0 16px;
  }
  
  .modal-body {
    padding: 16px;
  }
  
  .modal-title {
    font-size: 20px;
  }
  
  .privacy-content h3 {
    font-size: 16px;
  }
  
  .intro-section {
    padding: 16px;
  }
  
  .privacy-content ul {
    padding-left: 20px;
  }
}

@media (max-width: 480px) {
  .modal-content {
    max-width: 100%;
    margin: 10px;
  }
  
  .privacy-content h3 {
    font-size: 15px;
  }
  
  .privacy-content p,
  .privacy-content li {
    font-size: 13px;
  }
  
  .intro-section {
    padding: 12px;
  }
  
  .important-note,
  .contact-info,
  .company-info,
  .notice {
    padding: 12px;
  }
}
</style>
